var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0.3125C4.47581 0.3125 0 4.64844 0 10C0 15.3516 4.47581 19.6875 10 19.6875C15.5242 19.6875 20 15.3516 20 10C20 4.64844 15.5242 0.3125 10 0.3125ZM10 17.8125C5.55242 17.8125 1.93548 14.3086 1.93548 10C1.93548 5.69141 5.55242 2.1875 10 2.1875C14.4476 2.1875 18.0645 5.69141 18.0645 10C18.0645 14.3086 14.4476 17.8125 10 17.8125ZM8.06452 8.125C8.06452 8.81641 7.4879 9.375 6.77419 9.375C6.06048 9.375 5.48387 8.81641 5.48387 8.125C5.48387 7.43359 6.06048 6.875 6.77419 6.875C7.4879 6.875 8.06452 7.43359 8.06452 8.125ZM13.2258 9.375C13.9395 9.375 14.5161 8.81641 14.5161 8.125C14.5161 7.43359 13.9395 6.875 13.2258 6.875C12.5121 6.875 11.9355 7.43359 11.9355 8.125C11.9355 8.81641 12.5121 9.375 13.2258 9.375ZM10 13.75C11.3105 13.75 12.5484 13.1875 13.3871 12.2109C13.7298 11.8125 14.3427 11.7617 14.75 12.0898C15.1613 12.4219 15.2177 13.0117 14.875 13.4102C13.6653 14.8164 11.8871 15.6211 10 15.6211C8.1129 15.6211 6.33468 14.8164 5.125 13.4102C4.78629 13.0117 4.83871 12.4219 5.25 12.0898C5.65726 11.7617 6.27016 11.8125 6.6129 12.2109C7.45161 13.1914 8.68952 13.75 10 13.75Z",
    fill: "#2E2B63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetSmile);
export default __webpack_public_path__ + "static/media/getSmile.7dc6e907e57564357bd45a7cd17ce4f1.svg";
export { ForwardRef as ReactComponent };